// Dependencies
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from '@nephro/reportWebVitals';

// Messages translates
import '@nephro/core/i18n';

// Global Styles
import '@nephro/index.css';
import 'antd/dist/antd.css';

// Containers
import App from '@nephro/App';

const registerServiceWorker = async () => {
  await navigator?.serviceWorker?.register('/sw.js');
};

registerServiceWorker();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
